<template>
  <landing-page
    label="factSheet.heartDiseases"
    labelColor="#603813"
    descColor="#603813"
    :eggImgObj="{ componentName: 'factsheet', imgName: 'cornonaryArteryDiseaseLandingImage', imgFormat: 'png' }"
    :starBackgroundObj="{ componentName: 'shared', imgName: 'starGroupIconLightBrownRight', imgFormat: 'svg' }"
  />

  <div id="infoGroup" style="width: 60vw" class="fact-sheet-subpages pt-16 text-2xl font-jost space-y-12 m-auto pb-24">
    <div>
      <div class="font-bold text-description">{{ t("factSheet.introduction") }}</div>
      <div v-html="t('factSheet.heartDiseaseDesc')" class="space-y-5" />
    </div>

    <div>
      <div class="font-bold text-description">{{ t("factSheet.symptoms") }}</div>
      <div v-html="t('factSheet.heartDiseaseSymptomsDesc')" class="space-y-5" />
    </div>

    <div>
      <div class="font-bold text-description">{{ t("factSheet.riskFactors") }}</div>
      <div v-html="t('factSheet.heartDisaseRiskFactorsDesc')" class="space-y-5" />
    </div>

    <div>
      <div class="font-bold text-description">{{ t("factSheet.prevention") }}</div>
      <div v-html="t('factSheet.heartDiseasePreventionDesc')" class="space-y-5" />
    </div>

    <div v-html="t('factSheet.heartDiseaseRef')" />
    <!-- Chinese Version -->
    <section class="!font-sanstc space-y-12">
      <div>
        <div class="font-bold text-description text-center text-4xl">{{ t("factSheetChinese.heartDiseases") }}</div>
      </div>

      <div>
        <div v-html="t('factSheetChinese.heartDiseaseDesc')" class="space-y-5" />
      </div>

      <div>
        <div class="font-bold text-description">{{ t("factSheetChinese.symptoms") }}</div>
        <div v-html="t('factSheetChinese.heartDiseaseSymptomsDesc')" class="space-y-5" />
      </div>

      <div>
        <div class="font-bold text-description">{{ t("factSheetChinese.riskFactors") }}</div>
        <div v-html="t('factSheetChinese.heartDisaseRiskFactorsDesc')" class="space-y-5" />
      </div>

      <div>
        <div class="font-bold text-description">{{ t("factSheetChinese.prevention") }}</div>
        <div v-html="t('factSheetChinese.heartDiseasePreventionDesc')" class="space-y-5" />
      </div>

      <div v-html="t('factSheetChinese.heartDiseaseRef')" />
    </section>
  </div>
</template>

<script setup lang="ts">
import { useFactSheetStore } from "@/stores/factSheet";
import { useHeaderStore } from "@/stores/header";
import { computed, onMounted, ref, toRefs } from "vue";
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";

const factSheetStore = useFactSheetStore();
const headerStore = useHeaderStore();
const router = useRouter();
const { t, locale } = useI18n();

onMounted(async () => {
  headerStore.routerName = 'factsheet';
});

//not on home page, stop intro timer
router.beforeEach(async (to, from) => {});

const goTo = (refName) => {};

const routeTo = (position) => {
  router.push({ name: position, params: { uid: "lczmx" } });
};
</script>